@charset "UTF-8";

/* src/app/shared/components/truncated-paragraph/truncated-paragraph.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
p.truncated-paragraph {
  font-size: 0.8125em;
  line-height: 1.77;
  height: 5.7525em;
  overflow-y: auto;
  text-overflow: ellipsis;
  margin: 0;
}
p.truncated-paragraph.truncated {
  overflow: hidden;
}
p.truncated-paragraph.truncated .text::after {
  content: "\2026";
}
p.truncated-paragraph.truncated a {
  color: #00377e;
  font-weight: 700;
  text-decoration: underline;
}
/*# sourceMappingURL=truncated-paragraph.component.css.map */
